const LoadingSpinner = () => (
  <div className="flex justify-center items-center py-12">
    <div className="relative">
      <div className="w-12 h-12 rounded-full border-4 border-brand-100 border-t-brand-600 animate-spin"></div>
      <div className="absolute inset-0 flex items-center justify-center">
        <div className="w-6 h-6 rounded-full border-4 border-accent-100 border-b-accent-500 animate-spin" style={{ animationDirection: 'reverse', animationDuration: '0.6s' }}></div>
      </div>
    </div>
  </div>
);

export default LoadingSpinner;
